import * as types from './mutation-types'

export default {
  [types.SET_SUPPRESSIONS] (state, obj) {
    state.suppressions = obj
  }
}
